<template>
  <div class="container this-is-how-we-work">
    <div class="font-size-custom-max-48"><h1 id="font-calc-5">Zo werken wij</h1></div>
    <p>Wij zijn vaak eigenwijs, maar houden ons wel graag aan de onderstaande stappen. Deze stappen zijn grofweg een indicatie, geen case is namelijk hetzelfde!</p>
    <div class="how-we-work-icon-box">
      <div class="dotted-line-bg hidden" v-infocus="'showDottedLine'"></div>
      <div class="icon-container hidden" v-infocus="'showElementOne'">
        <!-- <h3>1.</h3>
        <h4>Dig</h4> -->
        <div class="img-content"><img src="../../assets/Folded_Paper_icon_dig.svg"></div>
      </div>
       <div class="icon-container hidden" v-infocus="'showElementTwo'">
        <!-- <h3>2.</h3>
        <h4>Dive</h4> -->
        <div class="img-content"><img src="../../assets/Folded_Paper_icon_dive.svg"></div>
      </div>
      <div class="icon-container hidden" v-infocus="'showElementThree'">
        <!-- <h3>3.</h3>
        <h4>Design</h4> -->
        <div class="img-content"><img src="../../assets/Folded_Paper_icon_design.svg"></div>
      </div>
       <div class="icon-container hidden" v-infocus="'showElementFour'">
        <!-- <h3>4.</h3>
        <h4>Deliver</h4> -->
        <div class="img-content"><img src="../../assets/Folded_Paper_icon_deliver.svg"></div>
      </div>
    </div>


    <scissorsButton>
     <router-link to="/werkwijze" class="button"><p>Je hebt me overtuigd!</p></router-link>
    </scissorsButton>
  </div>
</template>

<script>
import scissorsButton from '@/components/generalLayout/scissorsButton.vue';

export default {
  name: 'howWeWork',
   components:{
    scissorsButton
  },
    directives: {
    infocus: {
      isLiteral: true,
      inserted: (el, binding, vnode) => {
        let f = () => {
          let rect = el.getBoundingClientRect()
          let inView = (
            rect.width > 0 &&
            rect.height > 0 &&
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
          )
          if (inView) {
            el.classList.add(binding.value)
            window.removeEventListener('scroll', f)
          }
        }
        window.addEventListener('scroll', f)
        f()
      }
    }
   },
 methods: {
  noPageTransition() {
  },
  pageTransition() {
    window.location = './kiosk';
  },
  },
}
</script>

<style lang="scss" scoped>

.this-is-how-we-work{
    padding-bottom: layout-val-8(16);
    h1{
      display: table;
      margin: 0 auto;
      position: relative;
      top:0px;
      padding-bottom: layout-val-8(2);
    }
    p{
      text-align: center;
      max-width: 680px;
      margin: 0 auto;
      padding-bottom: layout-val-8(2);

    }
    img{
      max-width: 100%;
    }
    a{
      text-decoration: none;
      padding-bottom: 0px;
      p{
        font-weight: 900;
        padding-bottom: 8px;
      }
    }

    .how-we-work-icon-box{
      display: flex;
      position: relative;

      .dotted-line-bg{
        position: absolute;
        height: 1px;
        // border-bottom: 1px dotted;
        width: 1px;
        display: block;
        margin-left: layout-val-64(1);
        @include pos-center($axis: 'y');
        top:75%;

          // &:before{
          //   content:'';
          //   position: absolute;
          //   top:-8px;
          //   width: 100%;
          //   height: 1px;
          //   border-top: 1px solid;
          // }
          // &:after{
          //   content:'';
          //   position: absolute;
          //   top:8px;
          //   width: 100%;
          //   height: 1px;
          //   border-top: 1px solid;
          // } 
      }

      .showDottedLine{
       width: calc(100% - 128px);
      }

      .icon-container{
        flex: 1;
        
          h3,h4{
            text-align: center;
            font-family: $font-stack-copy;
            font-weight: 900;
          }
          h3{
            color: $yellow;
          }
          h4{
            opacity: 0.5;
             @include transition;
          }

            &:hover{
              h4{
                opacity: 1;
                @include transition;
              }
            }

          .img-content{
            max-width: 140px;
            max-height: 140px;
            width: 100%;
            height: 100%;
            margin: 0 auto;
            margin-top: layout-val-8(4);
            display: block;
            position: relative;
            pointer-events: none;

            img{
              pointer-events: all;
              z-index: 999;
              position: relative;
              @include transition;
              border-radius: 100px;

                &:hover{
                  transform: scale(1.3);
                  @include transition;
                  box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05), 0 10px 7px 0 rgba(0,0,0,0.02);
                }
            }
          
            //  &:after{
            //     content:'';
            //     border: 1px dotted $black;
            //     position: absolute;
            //     left: 0;
            //     top:0;
            //     width: 100%;
            //     height: 100%;
            //     border-radius: 100px;
            //     transform: scale(1.2);
            //     background: $white;
            //     z-index: 1;
            //   }
          }
      }
    }
}

@media screen and (max-width: 880px) {
  .this-is-how-we-work .how-we-work-icon-box{
    transform: scale(0.8);
  }
  .this-is-how-we-work .how-we-work-icon-box .icon-container .img-content{
    max-width: 120px;
    max-height: 120px;
  }
}

@media screen and (max-width: 670px) {
  .this-is-how-we-work .how-we-work-icon-box{
    transform: scale(0.7);
  }
  .this-is-how-we-work .how-we-work-icon-box .icon-container .img-content{
    max-width: 100px;
    max-height: 100px;
  }
}

@media screen and (max-width: 610px) {
  .this-is-how-we-work .how-we-work-icon-box .dotted-line-bg{
    display: none;
  }
  .this-is-how-we-work .how-we-work-icon-box .icon-container{
    margin-bottom: layout-val-8(4);
  }
  .this-is-how-we-work .how-we-work-icon-box{
    display: block;
    transform: scale(1);
  }
  .this-is-how-we-work .how-we-work-icon-box .icon-container .img-content{
    max-width: 120px;
    max-height: 120px;
  }
}
</style>